export const generateReceiptTharmalPrinter = (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails,
) => {
  return `
    <html>
    <head>
      <style>
       body {
  margin: 0;
  padding: 0;
}

.container {
  width: 80mm;
  margin: 0 auto;
  padding: 0 6px;   
  box-sizing: border-box;
}

@page {
  size: 80mm auto;
  margin: 0;
}
         .header {
    display: flex;
    flex-direction: column;
    justify-content: center; 
    align-items: center;         
    text-align: center;            
    color: #000;
    line-height: 1;
  border-bottom: 1px dashed #000;
  margin-top: 5px;
  padding-bottom: 5px;   
  margin-bottom: 5px;
  }

  .header2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: flex-start;         
    text-align: start;            
    color: #000;
    line-height: 1;
  border-bottom: 1px dashed #000;
  padding: 2px 0; 
  margin-bottom: 5px;  
  }
   .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1;
  border-bottom: 1px dashed #000;
  padding: 6px 0;   
                    }
    .headerTotal {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: flex-start;         
    text-align: start;            
    color: #000;
    line-height: 1.1;
  border-bottom: 1px dashed #000;
  padding: 6px 0;   
  }
  
 .headerEnd {
    text-align: center;            
    color: #000; 
     padding: 8px 0 6px;
  }
.textSizeLarge {
  font-size: 16px;
  margin: 1px; 
  padding: 1px;
  margin-bottom: 4px;
}
.textSizeMid {
  font-size: 10px;
  margin: 1px;
  padding: 1px; 
}
  .textSizeMid1 {
  font-size: 10px;
  margin: 1px;
  padding: 1px; 
  margin-bottom: 8px;
}

.textSizeSmall {
  font-size: 9px;
  margin: 1px;
  padding: 1px; 
}
.textWhite{
color:#fff !importent;
}

       .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th,
                    .order-details td { padding: 4px 2px; font-size: 10px; text-align: left; }
        .order-details2 th, 
        .order-details2 td { padding:5px; font-size: 10px; text-align: left;}
        .total-row { font-weight: bold; }
       
        .table-text-center{ text-align: center; }
      </style>
    </head>
    <body>
    <div id="receipt" class="container">
       <div class="header">
  <p class="textSizeLarge" style=" font-weight: 600;">${
    reciptDetails.business_name
  }</p>
  <p class="textSizeMid" > ${reciptDetails.address}</p>
  <p class="textSizeMid" >PH: ${reciptDetails.phone_no}</p>
  <p class="textSizeMid" >GST NO: ${reciptDetails.gst}</p>  
  <p class="textSizeLarge">** INVOICE **</p>
</div>
<div class="header2">
  <p class="textSizeMid" >Bill No: ${reciptDetails.bill_no}</p>
  <p class="textSizeMid" >Order No: ${item.daily_order_id}</p>
   <p class="textSizeMid" >Customer Name: ${item.customer_name}</p>
      <p class="textSizeMid" >Customer Mobile: ${item.customer_mobile}</p>
  <p class="textSizeMid" >Payment Status: ${item.payment_status}</p>  
  <p class="textSizeMid" >Printed: ${item.order_date}</p>  
  <p class="textSizeMid">
    Delivery Partner Name: ${
      item.delivery_person_name ? item.delivery_person_name : "Not assigned"
    }
</p>
<p class="textSizeMid">
    Delivery Partner Mobile No.: ${
      item.delivery_person_number ? item.delivery_person_number : "Not assigned"
    }
</p>
   <p class="textSizeMid1" >Delivery Address: ${fullAddress}</p> 
</div>
  <div class="headerTable">
                        <table class="order-details" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th class="table-text-center"></th>
                                    <th class="table-text-center">ITEM</th>
                                    <th class="table-text-center">QTY</th>
                                    <th class="table-text-center">PRICE</th>
                                    <th class="table-text-center">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${item.items
                                  .map(
                                    (subitem, index) => `
                                    <tr>
                                        <td class="table-text-center">${
                                          1 + index
                                        }</td>
                                        <td class="table-text-center">${
                                          subitem.product_id
                                        }</td>
                                        <td class="table-text-center">${
                                          subitem.quantity
                                        }</td>
                                        <td class="table-text-center">${
                                          subitem.item_price
                                        }</td>
                                        <td class="table-text-center">${
                                          subitem.total_price
                                        }</td>
                                    </tr>
                                `,
                                  )
                                  .join("")}
                            </tbody>
                        </table>
                    </div>
      <div class="headerTotal">
                       <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Sub Total :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${
                              item.subtotal
                            }</p>
                        </div>



                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Delivery Fee :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${
                              item.delivery_fee
                            }</p>
                        </div>

                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Other Fee :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${
                              item.other_fee
                            }</p>
                        </div>
                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Discount Percentage :</p>
                            <p class="textSizeMid" style="margin: 2px;">${
                              item.discount_percentage
                            }%</p>
                        </div>
                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Discount Amount :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${
                              item.discount_amount
                            }</p>
                        </div>
                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 600;">
                            <p class="textSizeMid" style="margin: 2px;">Total Amount :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${
                              item.totalOrderPrice
                            }</p>
                        </div>
                    </div>
             <div class="header2">
           
               <p class="textSizeMid1 " >Paid Amount : Rs. ${Number(
                 item.pay_amount,
               ).toFixed(2)}</p>
    
               
          </div>
  <div class="headerEnd">
            <p class="textSizeMid" >Thank you for your purchase!</p>
             <p class="textSizeSmall" > Order Managed By * ${reciptDetails.business_name} *</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
